import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { FormController } from '../shared/FormController';

export function RouteEditor({ setShow, route, routeList, setRouteList, index }) {
    const [model, setModel] = useState<any>();

    useEffect(() => {
        setModel(route)
    }, [route])    

    const handleCancel = () => {
        setShow(false)
    }

    const handleEdit = async event => {
        event.preventDefault();
        edit();
        setShow(false);
    };

    const edit = () => {
        var newRoute = {
            ...model
        }
        if(model.prevReadAt && !(model.prevReadAt instanceof Date)){
            newRoute.prevReadAt = new Date(new Date(new Date(model.prevReadAt).setDate(1+new Date(new Date(model.prevReadAt)).getDate())).setHours(0))
        }
        const result = Array.from(routeList);
        result.splice(index, 1, newRoute);
        setRouteList(result)
    };

    if(!model) return null;

    return (
        <Dialog
        open={true}
        onClose={handleCancel}
        aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">{route.routeNumber} - {route.utilityType ?? route.type}</DialogTitle>
            <DialogContent>
                <FormController
                    keys={{
                        customerName: {
                            type: 'string',
                            isNullable: true
                        },
                        location: {
                            type: 'string',
                            isNullable: true
                        },
                        prevRead: {
                            type: 'number',
                            isNullable: true
                        },
                        prevReadAt: {
                            format: 'date-time',
                            isNullable: true
                        },
                        highReadThreshold: {
                            type: 'number',
                            isNullable: true
                        },
                        lowReadThreshold: {
                            type: 'number',
                            isNullable: true
                        },
                    }}
                    disabledKeys={[]}
                    extraKeys={{}}
                    editMode={true}
                    model={model}
                    setModel={setModel}
                    canReadUserRoles={false}
                    canReadMeters={false}
                    canReadServiceAddresses={false}
                    districtId={null} />
            </DialogContent>
            <DialogActions>
                <Button
                    color="secondary"
                    onClick={handleCancel}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleEdit}
                    color="primary"
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}